export default __webpack_public_path__ + "static/media/oldBlackFriday.b2724e51.png";